import { IAccountResponse, UserChangeLog } from './account';

import { environment } from 'src/environments/environment';

export const issuingStatusFilterOptions = [
  { name: 'Under Construction' },
  { name: 'Active' },
  { name: 'Paused' },
  { name: 'Terminated' },
  { name: 'Archived' },
];

export const publisherIssuingStatusFilterOptions = [
  { name: 'Pending' },
  { name: 'Accepted' },
  { name: 'Rejected' },
];

export const transactionTypeFilterOptions = [
  { id: 'sale', name: 'Sale' },
  { id: 'lead', name: 'Lead' },
  { id: 'install', name: 'Install' },
  { id: 'impression', name: 'Impression' },
  { id: 'click', name: 'Click' },
];

export const dropdownSettings: object = {
  text: 'Select Countries',
  singleSelection: false,
  lazyLoading: true,
  selectAllText: 'Select All',
  unSelectAllText: 'Clear All',
  enableSearchFilter: true,
  classes: 'country-list',
  showCheckbox: true,
  labelKey: 'name',
};

export interface Offer {
  id: number;
  sid: string;
  name: string;
  status: string;
  logo: string;
  account: number;
  account_info: IAccountResponse;
  category: number;
  category_info: any;
  vertical: number;
  vertical_info: any;
  description: string;
  terms_and_conditions: string;
  targeted_countries: any;
  start_date: string;
  end_date: string;
  allow_deeplinking: string;
  postimpression_cookie_expiration_duration: string;
  postimpression_cookie_expiration_duration_unit: string;
  change_log: UserChangeLog[];
}

export interface OfferFilters {
  issuing_status_filter: any;
  transaction_type_filter: any;
  vertical_filter: any;
  category_filter: any;
  adspace_filter: any;
  advertiser_filter: any;
  traffic_filter: any;
  status_filter: any;
  publisher_status_filter: any;
  search_field: any;
  country_filter: any;
}

export const dateAndTimeConverter = (string: any) => {
  const date = new Date(string),
    month = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
  return [day, month, date.getFullYear()].join('-');
};

export const intervals = [
  'seconds',
  'minutes',
  'hours',
  'days',
  'weeks',
  'months',
  'years',
];

export const baseTextlink = {
  url: environment.API_URL,
  click: 'c',
  impression: 'i',
};

export const textlinkParameters = [
  { parameter: 'CLICK_ID' },
  { parameter: 'GAID' },
  { parameter: 'IDFA' },
  { parameter: 'REF1' },
  { parameter: 'REF2' },
  { parameter: 'REF3' },
  { parameter: 'REF4' },
  { parameter: 'REF5' },
  { parameter: 'SOURCE_ID' },
  { parameter: 'SUB_SOURCE_ID' },
  { parameter: 'WAID' },
];

export enum AdvertType {
  TEXT_LINK = 'Text Link',
  BANNER = 'Banner',
  PRODUCT_FEED = 'Product Feed',
  RICH_MEDIA = 'Rich Media',
  VOUCHER = 'Voucher',
}

export const EngagementTypes = [
  'Post Impression',
  'Post Click',
];

export enum CommissionPayoutType {
  FIXED = 'Fixed',
  PERCENTAGE = 'Percentage',
  HYBRID = 'Hybrid',
}

export const CommissionTypes = [
  CommissionPayoutType.FIXED,
  CommissionPayoutType.HYBRID,
  CommissionPayoutType.PERCENTAGE,
];

export const CurrencyTypes = [
  'EUR',
];

export enum OfferStatus {
  UNDER_CONSTRUCTION = 'Under Construction',
  ACTIVE = 'Active',
  PAUSED = 'Paused',
  TERMINATED = 'Terminated',
  ARCHIVED = 'Archived',
}
